import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { CONTACT, NAV, CATEGORIES, MEDIA } from "@/lib/data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0a0a0a] text-white">
      <div className="grain absolute inset-0" />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <img
            src={MEDIA.logo}
            alt="CETIBER — Sistemas de Fixação"
            className="h-20 w-auto object-contain mb-6"
          />
          <p className="text-sm text-white/70 leading-relaxed">
            Especialistas em sistemas de fixação e acessórios industriais. Soluções fiáveis para profissionais exigentes.
          </p>
        </div>

        <div>
          <div className="overline mb-5">Navegação</div>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  data-testid={`footer-nav-${n.to.replace("/", "") || "home"}`}
                  className="text-white/80 hover:text-[#1FA8E0] transition-colors font-display uppercase tracking-wider text-sm"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="overline mb-5">Categorias</div>
          <ul className="space-y-3">
            {CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link
                  to="/produtos"
                  className="text-white/80 hover:text-[#1FA8E0] transition-colors text-sm"
                >
                  {c.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="overline mb-5">Contactos</div>
          <ul className="space-y-4 text-sm text-white/80">
            <li className="flex gap-3">
              <MapPin size={18} className="text-[#1FA8E0] shrink-0 mt-0.5" />
              <span>
                Via Central de Milheiros 584<br />
                4475-330 Milheirós, Maia
              </span>
            </li>
            <li className="flex gap-3">
              <Phone size={18} className="text-[#1FA8E0] shrink-0 mt-0.5" />
              <a href={CONTACT.telefoneHref} className="hover:text-white">{CONTACT.telefone}</a>
            </li>
            <li className="flex gap-3">
              <Mail size={18} className="text-[#1FA8E0] shrink-0 mt-0.5" />
              <a href={CONTACT.emailHref} className="hover:text-white">{CONTACT.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div className="font-mono-cet tracking-widest">© {new Date().getFullYear()} CETIBER — TODOS OS DIREITOS RESERVADOS</div>
          <div className="font-mono-cet tracking-widest">MAIA · PORTUGAL</div>
        </div>
      </div>
    </footer>
  );
}
